module.exports = __webpack_public_path__ + "static/whatapp-share-usman-catering-224c78ce50434f760277831f42f51657.jpg";